<template>
    <Modal
            v-model="_value"
            width="500"
            title="海康录像使能"
            @on-visible-change="visibleChange"
            ok-text="关闭"
            cancel-text="">
        <Form ref="setecordingenabledModal" v-model="setecordingenabledModal" :label-width="80">

          <CheckboxGroup v-model="setecordingenabledModal">
<!--            <Checkbox label="通道1" border v-model="setecordingenabledModal.One"></Checkbox>-->
<!--            <Checkbox label="通道2" border v-model="setecordingenabledModal.Two"></Checkbox>-->
<!--            <Checkbox label="通道3" border v-model="setecordingenabledModal.Three"></Checkbox>-->
<!--            <Checkbox label="通道4" border v-model="setecordingenabledModal.Four"></Checkbox>-->
<!--            <Checkbox label="通道5" border v-model="setecordingenabledModal.Five"></Checkbox>-->
<!--            <Checkbox label="通道6" border v-model="setecordingenabledModal.Six"></Checkbox>-->
<!--            <Checkbox label="通道7" border v-model="setecordingenabledModal.Seven"></Checkbox>-->
            <Checkbox label="通道1" border></Checkbox>
            <Checkbox label="通道2" border></Checkbox>
            <Checkbox label="通道3" border></Checkbox>
            <Checkbox label="通道4" border></Checkbox>
            <Checkbox label="通道5" border></Checkbox>
            <Checkbox label="通道6" border></Checkbox>
            <Checkbox label="通道7" border></Checkbox>
          </CheckboxGroup>

            <Button type="primary" @click="onSendDriverCardParams">发送</Button>
        </Form>
    </Modal>
</template>

<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'hiksetrecordingenabledmodal',
  components: {},
  props: {
    initValue: null,
    terminalNumValue: null,
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      setecordingenabledModal: [],
      social:["录像使能"],
      JSON:"ValidChan:",
      JSONlist:["0","0","0","0","0","0","0","0"],
      JSONLast:";A!!!",
    }
  },
  methods: {
    ...mapActions([
      'VehicleInfoServ_SearchByName'
    ]),
    visibleChange (val) {
      if (val) {
        // this.setecordingenabledModal.One = 1
        // this.setecordingenabledModal.Two = 1
        // this.setecordingenabledModal.Three = 0
        // this.setecordingenabledModal.Four = 1
        // this.setecordingenabledModal.Five = 0
        // this.setecordingenabledModal.Seven = 0
      }
    },

    onSendDriverCardParams () {
      // console.log(this.setecordingenabledModal)
      if (this.setecordingenabledModal.length > 0) {
        for (let i = 0; i < this.setecordingenabledModal.length; i++) {
          // console.log(this.setecordingenabledModal[i])

          switch (this.setecordingenabledModal[i]) {
            case '通道1':
              this.JSONlist[this.JSONlist.length - 1] = "1"
              break
            case '通道2':
              this.JSONlist[this.JSONlist.length - 2] = "1"
              break
            case '通道3':
              this.JSONlist[this.JSONlist.length - 3] = "1"
              break
            case '通道4':
              this.JSONlist[this.JSONlist.length - 4] = "1"
              break
            case '通道5':
              this.JSONlist[this.JSONlist.length - 5] = "1"
              break
            case '通道6':
              this.JSONlist[this.JSONlist.length - 6] = "1"
              break
            case '通道7':
              this.JSONlist[this.JSONlist.length - 7] = "1"
              break

          }

          // console.log(this.JSONlist)
        }
      }
      // console.log(this.JSONlist.join(''))
      // console.log(parseInt(this.JSONlist.join(''),2))

      let content = this.JSON + parseInt(this.JSONlist.join(''),2) + this.JSONLast

      this.SendCommand(content)

    },
    SendCommand (content) {
      // console.log(content)
      // this.JSONlist = ["0","0","0","0","0","0","0","0"]
      store.dispatch('NetCommandServ_SendCommand', {
        params: { id: this._initValue, content: content, urgent: false }
      }).then(() => {
        this.$Message.success('发送成功')
        // this.JSON = "ValidChan:"
        this.JSONlist = ["0","0","0","0","0","0","0","0"]
      }).catch(err => {
        this.$Message.error(err)
        // this.JSON = "ValidChan:"
        this.JSONlist = ["0","0","0","0","0","0","0","0"]
      })
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _terminalNumValue: {
      get () {
        return this.terminalNumValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
